import React from "react";
import { useLocation, Link } from "react-router-dom";

const Search = () => {
  const { state } = useLocation();
  const results = state?.results || [];
  const query = state?.query || "";

  return (
    <div className="container mt-4">
      <h5>
        Search results for "<b>{query}</b>"
      </h5>

      {results.length === 0 ? (
        <p className="mt-3">No products found</p>
      ) : (
        <div className="row mt-3">
          {results.map((item) => (
            <div key={item.product_id} className="col-lg-3 col-md-4 col-sm-6 mb-4">
              <Link
                to={`/product/${item.product_id}`}
                className="text-decoration-none text-dark"
              >
                <div className="card h-100">
                  <img
                    src={
                      item.multi_image?.[0]
                        ? `https://cyberathon.com/multivendor/${item.multi_image[0]}`
                        : "/img/placeholder.png"
                    }
                    className="card-img-top"
                    alt={item.product_name}
                    style={{ height: "200px", objectFit: "contain" }}
                  />
                  <div className="card-body">
                    <h6 className="mb-1">{item.product_name}</h6>
                    <small className="text-muted">{item.company_name}</small>
                    <p className="fw-bold mt-1">₹{item.current_price}</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Search;
